export default __webpack_public_path__ + "static/media/grid-icon-vessel-edit.c2474a81.svg";